
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vida/computer-requirements",
      function () {
        return require("private-next-pages/vida/computer-requirements/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vida/computer-requirements"])
      });
    }
  